/**
 * SPDX-FileCopyrightText: (c) 2026 Liferay, Inc. https://liferay.com
 * SPDX-License-Identifier: LGPL-2.1-or-later OR LicenseRef-Liferay-DXP-EULA-2.0.0-2023-06
 */

import classNames from 'classnames';
import React from 'react';

import Context from './Context';

function Body({
	children,
	className,
	...otherProps
}: React.HTMLAttributes<HTMLDivElement>) {
	const {interactive} = React.useContext(Context);
	const TagName = interactive ? 'span' : 'div';

	return (
		<TagName className={classNames('card-body', className)} {...otherProps}>
			{children}
		</TagName>
	);
}

export default Body;
